import React from 'react';
import { MapPin, Navigation, Car, Landmark} from 'lucide-react';

const Location = () => {
  // Koordinat perkiraan Batu Lapisi Malino untuk Embed Google Maps
  const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15891.036691459529!2d119.856555!3d-5.269722!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dbee5df3be036bf%3A0x276564e95d29a34e!2sVilla%20Batulapisi%20Malino!5e0!3m2!1sid!2sid!4v1703410000000!5m2!1sid!2sid";

  return (
    <section className="bg-white font-poppins py-20 px-6 lg:px-24">
      <div className="max-w-7xl mx-auto">
        
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
          <div className="mb-6 md:mb-0">
            <h2 className="text-red-600 font-bold tracking-[0.3em] uppercase text-sm mb-4 flex items-center">
              <MapPin size={18} className="mr-2"/> Temukan Kami
            </h2>
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900">
              Lokasi & <span className="italic font-light text-red-600">Akses</span>
            </h1>
          </div>
          <div className="text-gray-500 max-w-sm text-sm">
            Terletak strategis di Batu Lapisi, memudahkan Anda menjangkau berbagai destinasi populer di Malino hanya dalam hitungan menit.
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          
          {/* KOLOM KIRI & TENGAH: Google Maps Embed */}
          <div className="lg:col-span-2 h-[450px] shadow-2xl border-4 border-white overflow-hidden relative group">
            <iframe 
              title="Lokasi Difa BallaEja"
              src={mapEmbedUrl}
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              className="grayscale-[20%] group-hover:grayscale-0 transition-all duration-700"
            ></iframe>
            <div className="absolute bottom-6 left-6">
               <a 
                 href="https://maps.app.goo.gl/seosrZMX5g4zT81W7?g_st=ipc" 
                 target="_blank" 
                 rel="noreferrer"
                 className="bg-red-600 text-white px-6 py-3 font-bold text-xs tracking-widest flex items-center space-x-3 hover:bg-black transition-colors"
               >
                 <Navigation size={16} />
                 <span>BUKA DI GOOGLE MAPS</span>
               </a>
            </div>
          </div>

          {/* KOLOM KANAN: Info Detail & Jarak Wisata */}
          <div className="space-y-6">
            <div className="bg-gray-900 p-8 text-white shadow-xl">
              <h3 className="text-xl font-serif font-bold mb-6 flex items-center">
                <Car size={24} className="mr-3 text-red-600" /> 
                Akses Kendaraan
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Villa kami dapat diakses dengan menggunakan kendaraan roda dua maupun roda empat.
              </p>
            </div>

            <div className="bg-gray-50 p-6 border-l-4 border-red-600 shadow-md">
              <h3 className="text-xl font-serif font-bold mb-6 flex items-center text-gray-800">
                <Landmark size={24} className="mr-3 text-red-600" /> 
                Titik Kenal Terdekat
              </h3>
              <ul className="space-y-4 text-sm font-medium">
                <li className="flex justify-between items-center text-gray-600">
                  <span>Kampoeng Eropa</span>
                  <span className="text-red-600 font-bold italic">500 Meter</span>
                </li>
                <li className="flex justify-between items-center text-gray-600">
                  <span>The River Malino</span>
                  <span className="text-red-600 font-bold italic">600 Meter</span>
                </li>
                <li className="flex justify-between items-center text-gray-600">
                  <span>Hutan Pinus</span>
                  <span className="text-red-600 font-bold italic">2 KM</span>
                </li>
                <li className="flex justify-between items-center text-gray-600">
                  <span>Malino Highlands</span>
                  <span className="text-red-600 font-bold italic">5 KM</span>
                </li>
                <li className="flex justify-between items-center text-gray-600">
                  <span>Sierra Sky View</span>
                  <span className="text-red-600 font-bold italic">8 KM</span>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Location;